/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const { deepReplaceVal } = require('src/common/utils/object');
const appConfig = require('rootPath/config/app/appBackend.json');
const apiData = require('./config/api.json');

//release环境的uri
// var prodUri = document.domain.indexOf('chargerlink.com') == -1 ? appConfig.prodUri : appConfig.onLineProdUri;
// console.log('------>',prodUri)

// var prodUri = 'http://192.168.60.241:8088/admin'

// var prodUri = 'http://test-app.mamobility.com/admin'   //测试环境
var prodUri = 'https://app.mamobility.com/admin'   //正式环境


    // var prodUri = 'http://sz-platform-appadmin.iot.renwochong.com'
    // var prodUri = 'http://app.admin.api.ayljny.com'
    //var prodUri = appConfig.prodUri;
var testUri = ""

const apiPath = deepReplaceVal({
    obj: apiData,
    cb(apiUrl) {
        if (/^(http|\/\/)/.test(apiUrl)) {
            return apiUrl;
        }

        //挑战不可能的接口域名
        if (apiUrl.indexOf("challenge") != -1){
            let host = prodUri == "http://test-app.mamobility.com/admin" ? "https://test-app.mamcharge.com" : "https://app.mamcharge.com";
            return `${host}${apiUrl}`;
        }

        return `${prodUri}${apiUrl}`;

        // return `${testUri}${apiUrl}`;
    }
});

module.exports = {
    apiPath
}



// WEBPACK FOOTER //
// ./service/appBackend/api.js